import logo from './logo.svg';
import './App.css';
import Chatbot from './components/Chatbot';

function App() {
  return (
    <div className="App">
     <h1>AI Chat Bot 🤖</h1>
     <Chatbot/>
    </div>
  );
}

export default App;
